<template>
  <form class="filters" @submit.prevent="filter">
    <div class="card">
      <header class="card-header is-size-4">
        <div class="card-header-title has-text-dark">
          <p>FILTERS</p>
        </div>
        <div class="buttons">
          <slot name="headerButtons" />
          <b-button type="is-white" @click="reset">
            <span class="icon"><i class="fa fa-times-circle fa-lg"></i></span>
          </b-button>
        </div>
      </header>
      <div class="card-content scrollable">
        <div class="columns is-multiline is-vcentered">
          <template v-for="field in defaultFields">
            <component
              v-show=" ! ['issuedBy', 'issuedTo'].includes(field.id)"
              :is="field.component"
              :value.sync="field.value"
              v-bind="field.props"
              :key="field.id"
              :ref="field.ref"
              @input="field.onInput"
            />
          </template>
        </div>
      </div>
      <footer class="card-footer">
        <div class="columns">
          <div class="column">
            <b-button
              id="submit_order_filter"
              name="submit_order_filter"
              class="is-fullwidth"
              native-type="submit"
              type="is-info"
            >
              Filter
            </b-button>
          </div>
        </div>
      </footer>
    </div>
  </form>
</template>

<script>
import { orderFilterMixin } from "@/components/OrderFilter/mixins/orderFilterMixin";

export default {
  mixins: [orderFilterMixin]
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/OrderFilter.vue